// extracted by mini-css-extract-plugin
export default {"root":"default-render-cell_root__17FjZ","placeHolderShimmer":"default-render-cell_placeHolderShimmer__cYEob"};